<div class="pricing-container" *ngIf="subscriptionPlans?.length">

  <h1 class="main-title yellow-heading">Subscriptions</h1>
  <p class="subtitle">Choose a plan that suits your learning journey.</p>

  <div class="table-wrapper">
    <table class="pricing-table">

      <!-- HEADER -->
      <thead>
        <tr>
          <th class="feature-col"></th>

          <th *ngFor="let plan of subscriptionPlans; let i = index" [class.popular]="i === 1">
            <div class="plan-header">

              <div class="badge" *ngIf="i === 2">Most Popular</div>

              <div class="plan-name">
                {{ plan.item.name }}
              </div>

              <div class="price">
                ₹{{ plan.item.amount / 100 }}
              </div>

              <div class="display-mrp">
                ₹{{ (plan.item.display_mrp) }}
              </div>

            </div>
          </th>
        </tr>
      </thead>

      <!-- FEATURES -->
      <tbody>
        <tr *ngFor="let feature of allFeatures">
          <td class="feature-col">{{ feature }}</td>

          <td *ngFor="let plan of subscriptionPlans" class="text-center">
            <span class="tick" *ngIf="plan.notes.includes(feature)">✔</span>

            <span class="cross" *ngIf="!plan.notes.includes(feature)">✖</span>
          </td>
        </tr>
      </tbody>

      <!-- CTA ROW -->
      <tfoot>
        <tr>
          <td></td>

          <td *ngFor="let plan of subscriptionPlans; let i = index">
            <button class="cta" [class.primary]="i === 2" [disabled]="isCreatingSubscription || isVerifyingPayment"
              (click)="onPayNowClick(plan)">
              {{
              loadingPlanId === plan._id
              ? 'Loading...'
              : isVerifyingPayment
              ? 'Verifying Payment...'
              : (i === 2 ? 'Get Started' : 'Choose Plan')
              }}
            </button>

            <p class="footer-text" [class.primary]="i === 2">
              {{ (i === 0 || i == 1)? 'For exploring' : i === 2 ? 'Most chosen' : 'For committed learners' }}
            </p>
          </td>
        </tr>
      </tfoot>

    </table>
  </div>

  <div class="note">
    Exclusive launch pricing with full access to <span class="logo-name">The <span class="lab">Lab</span>oratory
      Matters</span>
    learning ecosystem. Upgrade or downgrade anytime.
  </div>

</div>